import { useApiQuery } from 'hooks/useApiQuery'

export const useGetFeatureAccess = ({
  currentStateId = 0,
  enabled = true,
}: {
  currentStateId: number
  enabled?: boolean
}) => {
  return useApiQuery({
    path: '/featureaccess',
    method: 'get',
    queryKey: ['/featureaccess'],
    queryArgs: {},
    enabled,
    requestHeaders: currentStateId
      ? { 'Current-State-Id': currentStateId.toString() }
      : undefined,
  })
}
